import { render, staticRenderFns } from "./SendCertifiedEmailFirmaDialogComponent.vue?vue&type=template&id=2c747f52&lang=pug"
import script from "./SendCertifiedEmailFirmaDialogComponent.vue?vue&type=script&lang=ts"
export * from "./SendCertifiedEmailFirmaDialogComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c747f52')) {
      api.createRecord('2c747f52', component.options)
    } else {
      api.reload('2c747f52', component.options)
    }
    module.hot.accept("./SendCertifiedEmailFirmaDialogComponent.vue?vue&type=template&id=2c747f52&lang=pug", function () {
      api.rerender('2c747f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/firma/SendCertifiedEmailFirmaDialogComponent.vue"
export default component.exports